// extracted by mini-css-extract-plugin
module.exports = {"container":"specialPage_container__2jmFI"};